import { FC, useState } from "react";
import { QESButton, QESCheckbox, QESSelect } from "../shared/qes-standards";
import { toast } from "react-toastify";
import JobService from "./jobService";
import { JobQueue } from "./job-queues/jobQueue";

export interface JobCancelProps {
  started: boolean;
  jobQueueList: JobQueue[];
  jobIds: number[];
  onCompleted?: () => void;
}

export const JobCancel: FC<React.PropsWithChildren<JobCancelProps>> = (props: JobCancelProps) => {
  const jobService = new JobService();
  const [newQueueName, setNewQueueName] = useState("");
  const [requeueAfterCancel, setRequeueAfterCancel] = useState(false);

  function toastSuccess(message: string) {
    toast("Job(s): " + props.jobIds + message,
      {
        containerId: "z-index-9999",
        onOpen: props.onCompleted,
        type: "success",
      }
    )
  }

  function toastError(message: string) {
    if (message === undefined) {
      toast("An error occured when cancelling or requeuing job(s)",
        {
          containerId: "z-index-9999",
          onOpen: props.onCompleted,
          type: "error",
        },
      );
    }
    else {
      toast("An error occured when cancelling job(s). Error: " + message,
        {
          containerId: "z-index-9999",
          onOpen: props.onCompleted,
          type: "error",
        },
      );
    }
  }

  const cancelJobButtonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (props.started) {
      jobService.cancelStartedJobById(props.jobIds, requeueAfterCancel).then(() => {
        if (requeueAfterCancel) {
          toastSuccess(" cancelled and requeued successfully.");
        }
        else {
          toastSuccess(" cancelled successfully.");
        }
      }, (error) => {
        toastError(error.responseJSON?.detail);
      }
      );
      return;
    }
    if ((!props.started) && (requeueAfterCancel)) {
      jobService.changeJobQueue(props.jobIds, newQueueName).then(() => {
        toastSuccess(" succesfully cancelled and move to queue: " + newQueueName + ".");
      },
        (error) => {
          toastError(error.responseJSON?.detail);
        }
      );
      return;
    }
    if (!props.started) {
      jobService.cancelQueuedJobById(props.jobIds).then(() => {
        toastSuccess("  cancelled successfully.");
      }, (error) => {
        toastError(error.responseJSON?.detail);
      }
      );
      return;
    }
  }

  return (
    <div className="row">
      <QESButton
        disabled={props.jobIds.length == 0 || ((requeueAfterCancel) && (newQueueName == "") && (!props.started))}
        onClick={cancelJobButtonHandler}
        className="ml-2 mr-1"
        qesType="primary-danger"
        qesTestId={"jobs-list__cancel-job-button"}>Cancel Job(s)</QESButton>
      <QESCheckbox
        disabled={props.jobIds.length == 0}
        containerClassName="ml-2 mr-2"
        testId="job-list__requeue-job"
        label="Requeue"
        onChange={(e) => setRequeueAfterCancel(e.target.checked)} checked={requeueAfterCancel} />
      {
        !props.started && (
          <QESSelect
            allowEmpty={true}
            containerClassName="jobs-list__requeue-job-queue-list"
            testId="jobs-list__requeue-list"
            label=""
            placeholder="Select a Queue"
            onChange={(e) => setNewQueueName(e.target.value)}
            disabled={!requeueAfterCancel}
            value={newQueueName} >
            {props.jobQueueList.map(item => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </QESSelect>
        )
      }
    </div>)
}
